import { render, staticRenderFns } from "./SideNav.vue?vue&type=template&id=2ea92ee9&scoped=true&"
import script from "./SideNav.vue?vue&type=script&lang=js&"
export * from "./SideNav.vue?vue&type=script&lang=js&"
import style0 from "./SideNav.vue?vue&type=style&index=0&id=2ea92ee9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea92ee9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ea92ee9')) {
      api.createRecord('2ea92ee9', component.options)
    } else {
      api.reload('2ea92ee9', component.options)
    }
    module.hot.accept("./SideNav.vue?vue&type=template&id=2ea92ee9&scoped=true&", function () {
      api.rerender('2ea92ee9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wla/SideNav.vue"
export default component.exports